<script lang="ts">
	import type { PageProps } from "./$types";
	import {
		FAQ,
		HomePageHero,
		FreeQuote
	} from "#lib/web-ui/home-buyers-template/content/index.js";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";

	const templateContext = getTemplateContext();

	let { data }: PageProps = $props();

	const heroTitle = "Trusted Home Buyers";
	const heroSubTitle = `${templateContext.siteName} purchases homes throughout the Crossroads area. We pay cash fast and close on your timeline.`;
</script>

<HomePageHero
	title={heroTitle}
	subTitle={heroSubTitle}
	imageUrl={templateContext.images.teamHero}
/>

<!-- Not Serviced Content Section -->
<div class="bg-white py-24 sm:py-32">
	<div class="mx-auto max-w-7xl px-6 lg:px-8">
		<div class="mx-auto max-w-2xl lg:max-w-4xl">
			<div class="text-center">
				<h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
					{#if data.location}
						We're Not Currently Servicing {data.location}
					{:else}
						Area Not Currently Serviced
					{/if}
				</h2>
				<div class="mt-6 space-y-4 text-lg leading-8 text-gray-600">
					<p>
						{#if data.location}
							Thank you for your interest in selling your property in {data.location}.
							Unfortunately, we don't currently purchase properties in your area.
						{:else}
							Thank you for your interest in selling your property. Unfortunately, we
							don't currently purchase properties in the area you searched for.
						{/if}
					</p>
					<p>
						We're continuously expanding our service areas throughout Texas. We'd love
						to keep you informed when we start serving your area.
					</p>
				</div>
			</div>

			<!-- Contact Form or Info -->
			<div class="mt-16 rounded-2xl bg-gray-50 p-8 sm:p-10">
				<h3 class="mb-4 text-2xl font-bold tracking-tight text-gray-900">Stay Updated</h3>
				<p class="mb-6 text-base leading-7 text-gray-600">
					Please reach out to us and we'll let you know if and when we expand to your
					area. In the meantime, we're happy to provide guidance or answer any questions
					you may have about selling your property.
				</p>
				<div class="space-y-4">
					<div class="flex items-start">
						<div class="flex-shrink-0">
							<svg
								class="text-primary-600 h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
								/>
							</svg>
						</div>
						<div class="ml-3">
							<p class="text-base font-semibold text-gray-900">Phone</p>
							<p class="mt-1 text-base text-gray-600">
								<a
									href="tel:{templateContext.contact.phone}"
									class="hover:text-primary-600"
								>
									{templateContext.contact.phone}
								</a>
							</p>
						</div>
					</div>
					<div class="flex items-start">
						<div class="flex-shrink-0">
							<svg
								class="text-primary-600 h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
								/>
							</svg>
						</div>
						<div class="ml-3">
							<p class="text-base font-semibold text-gray-900">Email</p>
							<p class="mt-1 text-base text-gray-600">
								<a
									href="mailto:{templateContext.contact.email}"
									class="hover:text-primary-600"
								>
									{templateContext.contact.email}
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<FAQ />
